module.exports = __webpack_public_path__ + "static/img/login_bg_logo.2bbc395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg_logo.png
// module id = BYuE
// module chunks = 2